import React from 'react';
import FeatureTooltip from 'components/FeatureToolTip';

export default function MainEditorTooltipLayer({ sequence }) {
  if (!sequence?.activeTooltip) return null;

  const tooltip = sequence.activeTooltip;

  return (
    <FeatureTooltip
      targetRef={tooltip.ref}
      open={true}
      placement={tooltip.placement || 'right'}
      align={tooltip.align || 'center'}
      title={tooltip.title}
      description={tooltip.description}
      buttonLabel="Got it"
      secondaryButtonLabel="Skip all tips"
      onClose={() => sequence.closeTooltip(tooltip.id)}
      onSecondaryClick={sequence.skipAllTooltips}
    />
  );
}
